import { GDPRUserDeletionPeriod } from "../gdprTypes"
import { UnreachableCaseError } from "../../../../../../lib/lang"

export function mapDeletionPeriodToDays(period: GDPRUserDeletionPeriod): string {
    switch (period) {
        case GDPRUserDeletionPeriod.DAYS_180:
            return "180"
        case GDPRUserDeletionPeriod.DAYS_90:
            return "90"
        case GDPRUserDeletionPeriod.DAYS_30:
            return "30"
        case GDPRUserDeletionPeriod.DAYS_7:
            return "7"
        default:
            throw new UnreachableCaseError(period)
    }
}
